import { Routes } from '@angular/router';

// 3D sistemi (fiko-three-js) micro-frontend route'u.
// Bileseni lazy yukluyoruz: three bu remote'un chunk'inda paketlenir,
// diger MFE'lerin ana paketine girmez.
export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@shared/service/fikoyt-ui/src/lib/fiko-three-js/fiko-three-js.component').then(
        (m) => m.FikoThreeJsComponent,
      ),
  },
];